/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_ButtonInputs */



/**
* | output |
* | --- |
* | "Add users" |
*
* @param {Team_Manager_Add_Users_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_button = /** @type {((inputs?: Team_Manager_Add_Users_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des utilisateurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi utenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить пользователей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir usuarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar utilizadores")
	return /** @type {LocalizedString} */ ("Add users")
});